import { BaseMessageInfo } from "./BaseMessageInfo";
import { AssignTechDispatchBus } from "./AssignTechDispatchBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { VisitsCountBus } from "./VisitsCountBus";
import { CommonFunctions } from "../static/common-functions";

export class AssignTechMessageInfo extends BaseMessageInfo
{
    constructor(data: AssignTechMessageInfo = null) {
        super(data);
        if (data !== null) {
            this.dispatch = new AssignTechDispatchBus(data.dispatch);
            this.locationDetail = new v_LocationDetailBus(data.locationDetail);
            if (CommonFunctions.hasArrayElementValue(data.techsVisited)) {
                let arr = [];
                for (let i = 0; i < data.techsVisited.length; i++) {
                    let vcBusObj: VisitsCountBus = new VisitsCountBus(data.techsVisited[i]);
                    arr.push(vcBusObj);
                }
                this.techsVisited = arr;
            }
        }
    }
    dispatch: AssignTechDispatchBus;
    locationDetail: v_LocationDetailBus;
    techsVisited: VisitsCountBus[];
}
